import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { errMsg } from "./OutreachSendButton";
import { ED } from "./ActionButtons";

// « Remplacer » : choisir une autre photo (visuels déjà importés pour ce sujet + médiathèque) — l'image principale du BROUILLON est remplacée ; aucune ressource non photographique ; jamais sur un article publié.
export const VisualReplace = ({ subjectId, onDone, onClose }) => {
  const [data, setData] = useState(null);
  useEffect(() => { axios.get(`${ED}/subjects/${subjectId}/visuals/replacements`).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e))); }, [subjectId]);
  const use = async (photoId) => {
    try { await axios.post(`${ED}/subjects/${subjectId}/visuals/replace`, { photo_id: photoId }); toast.success("Image remplacée"); onDone?.(); onClose?.(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!data) return null;
  return (
    <div className="border rounded p-2 space-y-2 bg-slate-50" data-testid={`intel-visual-replace-${subjectId}`}>
      <p className="text-sm font-semibold">Remplacer l'image du brouillon par :</p>
      {data.options.length === 0 && <p className="text-xs text-muted-foreground">Aucune autre photo disponible pour ce sujet. Validez d'abord un autre visuel officiel ou ajoutez une photo à la médiathèque.</p>}
      <div className="flex flex-wrap gap-3">
        {data.options.map((o) => (
          <div key={o.photo_id} className="w-36 space-y-1">
            {o.url ? <img src={o.url} alt={o.description || o.filename || "photo"} className="h-24 w-36 object-cover rounded border" loading="lazy" /> : <div className="h-24 w-36 rounded border bg-white text-xs flex items-center justify-center">{o.filename}</div>}
            <Button size="sm" variant="outline" className="w-full" onClick={() => window.confirm("Utiliser cette photo comme image du brouillon ?") && use(o.photo_id)} data-testid={`intel-visual-use-${o.photo_id}`}>Utiliser celle-ci</Button>
          </div>
        ))}
      </div>
      <Button size="sm" variant="ghost" onClick={onClose}>Annuler</Button>
    </div>
  );
};
